
jQuery(document).ready(function($) {
	
	if($('.pswp').length == 0)
		return;
	
	var pswp = $('.pswp')[0];
	var items = [];
	var options = {
		captionEl: false,
		fullscreenEl: false,
		shareEl: false,
		clickToCloseNonZoomable: false
	};

	$('.photos figure').each(function() {
		var link = $(this).find('a');
		items.push({
			src: link.attr('href'),
			w: 0,
			h: 0
		});
	});
			
	$('.photos figure a').on('click', function(e) {
		e.preventDefault();
		
		options.index = $(this).parent('figure').index();
		
		var gallery = new PhotoSwipe(pswp, PhotoSwipeUI_Default, items, options);
	
		gallery.listen('gettingData', function(index, item) {
			if (item.w < 1 || item.h < 1) {
				var img = new Image();
				img.onload = function () {
					item.w = this.width;
					item.h = this.height;
					gallery.updateSize(true);
				};
				img.src = item.src;
			}
		});
		
		gallery.init();	
		
	});
	
});